import { CompanySearchRequest } from '../../../../generated/model/models';
import {
  AppliedFilterInterface,
  FlattenedLibraryFilters,
  LibraryFilterItem,
} from './FinancialDataContext.types';

export const appendParent = (items: LibraryFilterItem[], parent = ''): LibraryFilterItem[] => {
  return items.map((item) => {
    if (parent) {
      item.parent = parent;
    }

    if (item.children && item.children.length) {
      item.children = appendParent(item.children, parent || item.labelKey);
    }

    return item;
  });
};

export const flattenFilters = (filters: LibraryFilterItem[]): FlattenedLibraryFilters => {
  return filters.reduce((acc: FlattenedLibraryFilters, filter) => {
    if (filter.children && filter.children.length) {
      acc = { ...acc, ...flattenFilters(filter.children) };
    }
    if (filter.type) {
      acc[filter.labelKey] = filter;
    }

    return acc;
  }, {});
};

export const mandatoryFilters = (
  flatFilters: FlattenedLibraryFilters,
): AppliedFilterInterface[] => {
  const result: AppliedFilterInterface[] = [];

  Object.keys(flatFilters).forEach((key) => {
    if (flatFilters[key] && flatFilters[key].mandatory) {
      result.push(key);
    }
  });

  return result;
};

const removeEmptyFilters = (filters: any) => {
  const result: any = {};

  Object.keys(filters).forEach((key) => {
    if (filters[key]) {
      result[key] = filters[key];
    }
  });

  return result;
};

export const parseSearchRequest = (
  searchRequest: CompanySearchRequest,
  libraryFilters: LibraryFilterItem[],
) => {
  const historySearch = searchRequest.historySearch || false;
  const data = removeEmptyFilters(searchRequest.filters);
  const filtersOrder = getFiltersOrder(libraryFilters);
  const appliedFilters = filtersOrder.filter((labelKey: string) => data[labelKey]);

  return { historySearch, data, appliedFilters };
};

export const getFiltersOrder = (filters: LibraryFilterItem[]) => {
  return filters.reduce((acc: any, filter) => {
    if (filter.children && filter.children.length) {
      acc = acc.concat(getFiltersOrder(filter.children));
    }
    if (filter.type) {
      acc.push(filter.labelKey);
    }

    return acc;
  }, []);
};
